import cn from 'classnames';
import styles from './highlightTabs.module.scss';

type HighlightTabProps = {
  label?: string;
  isPlaceholder: boolean;
};
const HighlightTab = ({ label = 'Most Popular', isPlaceholder = false }: HighlightTabProps) => {
  const containerStyles = cn(styles.mostPopularTab, {
    [styles.placeholder]: isPlaceholder,
  });

  return (
    <div className={containerStyles}>
      <p className="h6">{isPlaceholder ? '\u00a0' : label}</p>
    </div>
  );
};

export default HighlightTab;
